__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/847aeef1afdb90c59fb2f7601f7c896f7e76cc41/_next/";